module.exports = __webpack_public_path__ + "static/media/RUSSELL K. RED 50 LOUDSPEAKERS.419288fa.png";